import React from 'react'
import { Dropdown, Form } from 'react-bootstrap'
import { CrossClientQueryClientQueryMode, CrossClientQueryClientQueryModes } from '../../../../models/CrossClient'
import { CLIENT_MODE_LABEL } from '../../utils'

interface CrossClientClientsPillProps {
  mode: CrossClientQueryClientQueryMode
  onChange: (mode: CrossClientQueryClientQueryMode) => void
  disabled?: boolean
}

export const CrossClientClientsPill: React.FC<CrossClientClientsPillProps> = ({ mode, onChange, disabled }) => {
  const includesShared = mode === CrossClientQueryClientQueryModes.WITH_SHARED
  const toggleShared = () => {
    onChange(includesShared ? CrossClientQueryClientQueryModes.ONLY_OWNED : CrossClientQueryClientQueryModes.WITH_SHARED)
  }

  return (
    <Dropdown autoClose='outside'>
      <Dropdown.Toggle as='button' bsPrefix='cross-client-pill' className='cross-client-pill d-flex gap-1 align-items-center' disabled={disabled}>
        <span className='paragraph-small bold'>Clients:</span>
        <span className='paragraph-small'>{CLIENT_MODE_LABEL[mode]}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu className='cross-client-popover'>
        <div className='paragraph-medium'>
          Your clients are always included.
          <br />
          Add shared clients for more results?
        </div>
        <label className='d-flex align-items-center gap-2 cross-client-popover-row mb-0'>
          <Form.Check className='d-flex' type='checkbox' checked={includesShared} onChange={toggleShared} />
          <span className='paragraph-medium'>Include shared clients</span>
        </label>
      </Dropdown.Menu>
    </Dropdown>
  )
}
